import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { InventoryEntities } from 'client/data/models/inventory';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';
import { DEFAULT_PRICE } from 'client/site-modules/shared/components/deal/deal-constants';
import './inventory-price.scss';

export function makePrice(price) {
  return price && price > 500 ? formatPriceString(price) : DEFAULT_PRICE;
}

export function InventoryPrice({
  type,
  prices: { displayPrice } = {
    displayPrice: 0,
  },
  bestDealPrice = 0,
  priceClasses = 'display-4 fw-bold',
  priceNameClasses = 'pe-0_5 small',
  priceNameUsed = 'List:',
  priceNameNew = 'MSRP:',
  forceStrikethrough = false,
  isBestDealPriceEnabled = false,
}) {
  const isUsedCar = isUsed(type);
  const price = makePrice(isBestDealPriceEnabled ? bestDealPrice : displayPrice);

  return (
    <Fragment>
      <span className={priceNameClasses}>{isUsedCar ? priceNameUsed : priceNameNew}</span>
      <span className={priceClasses}>{forceStrikethrough && !isBestDealPriceEnabled ? <s>{price}</s> : price}</span>
    </Fragment>
  );
}

InventoryPrice.propTypes = {
  type: PropTypes.string.isRequired,
  prices: InventoryEntities.Prices,
  bestDealPrice: PropTypes.number,
  priceClasses: PropTypes.string,
  priceNameClasses: PropTypes.string,
  priceNameUsed: PropTypes.string,
  priceNameNew: PropTypes.string,
  forceStrikethrough: PropTypes.bool,
  isBestDealPriceEnabled: PropTypes.bool,
};
